import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { GiMoneyStack, GiReceiveMoney } from 'react-icons/gi';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { Button, Collapse } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import React, { useEffect, useState } from 'react';
import UserCard from '../../components/userCard';
import useAuth from '../../hooks/useAuth';
import { customTotal, pageButtonRenderer } from '../../common/constants';
import CardAction from '../../components/cardAction';
import { logout } from '../../services/MockAuthService';
import IdleTimer from '../../services/idleTimer';
import AlertTimeout from '../../components/alertTimeout';

function Dashboard() {
  const title = 'Dashboard';
  const navigate = useNavigate();
  const { getSession } = useAuth();
  const { getMemberProfile } = useAuth();
  const user = getSession();
  const member = getMemberProfile();
  const { getDependent } = useAuth();
  const dependent = getDependent();
  const [open, setOpen] = useState(true);
  // const [isLoading, setIsLoading] = useState(false);
  // const [hideForm, setHideForm] = useState(false);

  const [isTimeout, setIsTimeout] = useState(false);
  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsTimeout(true);
  };
  useEffect(() => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const columns = [{
    dataField: 'FIRST_NAME',
    text: 'First Name',
  },
  {
    dataField: 'LAST_NAME',
    text: 'Last Name',
  },
  {
    dataField: 'DOB',
    text: 'Date of Birth',
  },
  {
    dataField: 'RELATIONSHIP',
    text: 'Relation',
  },
  {
    dataField: 'SEX',
    text: 'Gender',
  },
  {
    dataField: 'STATUS',
    text: 'Status',
  },
  ];
  const options = {
    pageButtonRenderer,
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: '5', value: 5,
    }, {
      text: '10', value: 10,
    }, {
      text: 'All', value: dependent.length,
    }], // A numeric array is also available. the purpose of above example is custom the text
  };
  const validators = {
    nida_no: {
      required: {
        value: true,
        message: 'Nida No is required',
      },
    },
    email: {
      required: {
        value: true,
        message: 'email is required',
      },
    },
    mobile_no: {
      required: {
        value: true,
        message: 'Mobile No is required',
      },
    },
  };

  const dependantLoad = () => {
    if (dependent.length > 0) {
      return <span>
        <div className="table-responsive">
        <BootstrapTable
          bootstrap4
          keyField='id'
          data={ dependent }
          columns={ columns }
          pagination={ paginationFactory(options) }
          striped
          hover
          condensed
        />
      </div>
      </span>;
    }
    return <span>
      <p className="text-center">No dependents found</p>
    </span>;
  };

  const onCancel = () => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
        setIsTimeout(true);
      },
    });
    setIsTimeout(false);
    return () => {
      timer.cleanUp();
    };
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item active><Link to="/console/dashboard">{title}</Link></Breadcrumb.Item>
          </Breadcrumb>
          <h1 className="page-title">{title}</h1>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="card card-stats mb-xl-0">
                    <div className="card-body">
                      <div className="row">
                        <div className="col">
                          <h5 className="card-title text-uppercase text-muted mb-0">Contributions</h5>
                          <span className="t-font font-weight-bold mb-0">
                          TZS {(member.UnpaidContributions) ? (member.UnpaidContributions).toLocaleString({ minimumFractionDigits: 2 })
                            : 0
                          }/=</span>
                        </div>
                        <div className="col-auto">
                          <GiMoneyStack className="card-icon"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card card-stats mb-4 mb-xl-0">
                    <div className="card-body">
                      <div className="row">
                        <div className="col">
                          <h5 className="card-title text-uppercase text-muted mb-0">Credits </h5>
                          <span className="t-font font-weight-bold mb-0">
                          {(member.UnpaidCredits) ? (member.UnpaidCredits).toLocaleString(navigator.language, { minimumFractionDigits: 2 })
                            : 0
                          }</span>
                        </div>
                        <div className="col-auto">
                          <div className="col-auto">
                            <GiReceiveMoney className="card-icon"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <div className="card mb-4 mb-lg-0">
                  <div className="card-body p-0">
                    <CardAction/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-4">
                  <div className="card mb-4 mb-lg-0">
                    <h6 className="card-header d-flex justify-content-between align-items-center">
                      Employer
                      <Button
                        className="btn-sm btn-collapse"
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      >{(open) ? <IoIosArrowUp/> : <IoIosArrowDown/> }
                      </Button>
                    </h6>
                    <Collapse in={open}>
                      <div className="card-body p-0">
                        <ul className="list-group list-group-flush rounded-3">
                          <li className="list-group-item align-items-start d-flex p-3">
                            <div className="col-lg-6">
                              <p className="mb-0">Employer: <span className="text-muted">
                            {(member.EmployerName) ? member.EmployerName : ''}</span></p>
                            </div>
                            <div className="col-lg-6">
                              <p className="mb-0">Employer ID: <span>{(member.EmployerId) ? member.EmployerId : ''}</span></p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Collapse>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="card">
                    <h6 className="card-header d-flex justify-content-between align-items-center">
                      Dependants
                      <Button
                        className="btn btn-sm btn-collapse"
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      >{(open) ? <IoIosArrowUp/> : <IoIosArrowDown/> }
                      </Button>
                    </h6>
                    <Collapse in={open}>
                      <div className="card-body">
                        {dependantLoad()}
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {isTimeout
        && <AlertTimeout onConfirm={handleLogout} onCancel={onCancel}/>
        }
      </>
    );
  }
  navigate('/login');
}

export default Dashboard;
